<template>
  <div>
    <div class="m-1 border rounded border-blue-300 p-5 flex">
      <!-- メール送信画面 -->
      <div class="mail-form">
        <!-- 送信元 -->
        <div class="flex text-sm my-auto font-bold mb-2 text-blue-800">
          <div class="self-center">送信元アドレス：</div>
          <select
            v-if="edit"
            name="senderMail"
            v-model="estimate.clientMail.senderMail"
            class="border-gray-300 rounded py-1 font-bold "
          >
            <option
              v-for="(o, i) in senderMailList" :key="'sm' + i"
              :value="o.e_mail_adress"
              class="bg-white">
              {{ o.e_mail_adress }}
            </option>
          </select>
          <div v-else>
            {{ estimate.clientMail.senderMail }}
          </div>

          <div v-if="edit&&estimate.clientMail.senderMail" class="mx-1 cursor-pointer text-xs ml-auto mr-3 border-b border-blue-700 self-center font-bold" @click="openMailPass=!openMailPass">
            メールパスワード編集
          </div>
        </div>

        <!-- メールパスワード編集 -->
        <div v-if="openMailPass" class="p-3 mt-1 mb-3 border border-blue-600 bg-blue-50 rounded">
          <div class="text-xs font-bold text-red-700">メールパスワードを入力してください</div>
          <input 
            type="text"
            class="cursor-text border-gray-300 rounded w-full focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            v-model="mailPass"
          />
          <PrimaryButton
            v-if="edit"
            text="メールパスワード保存"
            @click="saveMailPass()"
            class="m-1"
          >
          </PrimaryButton>
        </div>
        <!-- メールアドレス -->
        <div class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto text-gray-700">送信先
              <span v-if="edit" class="-top-0.5 ml-1 text-red-500"> * </span>
            </div>
            <PrimaryButton
              v-if="edit"
              text="送信先追加"
              @click="mailAdd"
              class="h-7 bg-blue-50 text-blue-900 border-blue-900 m-1 w-40"
            >
              <Icon
                iconName="PlusCircle" 
                slot="before"
                class="w-4 h-4 mr-0.5"
              />
            </PrimaryButton>
          </div>
          <div v-for="(m, i) in estimate.clientMail.mail" :key="i">
            <div v-if="edit" class="flex">
              <WmsSuggestInput
                :name="'m' + i"
                :selectionItems="mailList"
                :displayField="['clientName', 'clientName2', 'name', 'mail']"
                class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500"
                v-model="estimate.clientMail.mail[i]"
                @selected="mailSelected($event, estimate.clientMail.mail, i)"
              ></WmsSuggestInput>
              <div v-tooltip="'メールアドレスをマスタに保存'" class="mx-1 cursor-pointer" @click="saveMail(m)">
                <Icon
                  iconName="Save" 
                  class="w-6 h-10 text-indigo-600"
                />
              </div>
              <div class="m-auto ml-2">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="mailDelete(i)"/>
              </div>
            </div>
            <div v-else class="mb-3">
              <div class="border rounded border-gray-300 py-2 px-3 text-sm w-full">
                {{ m }}
              </div>
            </div>
          </div>
        </div>
        <!-- CC -->
        <div v-if="edit" class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto text-gray-700">CC</div>
            <PrimaryButton
              text="CC追加"
              @click="ccAdd"
              class="h-7 bg-blue-50 text-blue-900 border-blue-900 mx-1 w-40"
            >
              <Icon
                iconName="PlusCircle" 
                slot="before"
                class="w-4 h-4 mr-0.5"
              />
            </PrimaryButton>
          </div>
          <div v-for="(m, j) in estimate.clientMail.cc" :key="'cc'+j">
            <div class="flex">
              <WmsSuggestInput
                :name="'cc' + j"
                :selectionItems="ccList"
                :displayField="['user_name', 'e_mail_adress']"
                class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500"
                v-model="estimate.clientMail.cc[j]"
                @selected="mailSelected($event, estimate.clientMail.cc, j)"
              ></WmsSuggestInput>
              <div class="m-auto ml-2">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="ccDelete(j)"/>
              </div>
            </div>
          </div>
        </div>
        <!-- 参照画面 -->
        <div v-else-if="cc.length" class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto text-gray-700">CC</div>
          </div>
          <div v-for="(m, j) in cc" :key="'cc'+j">
            <div class="border rounded border-gray-300 py-2 px-3 text-sm w-full">
              {{ cc[j] }}
            </div>
          </div>
        </div>
        <!-- BCC -->
        <div v-if="edit" class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto text-gray-700">BCC</div>
            <PrimaryButton
              text="BCC追加"
              @click="bccAdd"
              class="h-7 bg-blue-50 text-blue-900 border-blue-900 mx-1 w-40"
            >
              <Icon
                iconName="PlusCircle" 
                slot="before"
                class="w-4 h-4 mr-0.5"
              />
            </PrimaryButton>
          </div>
          <div v-for="(m, j) in estimate.clientMail.bcc" :key="'bcc'+j">
            <div class="flex">
              <WmsSuggestInput
                :name="'bcc' + j"
                :selectionItems="ccList"
                :displayField="['user_name', 'e_mail_adress']"
                class="w-full border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500"
                v-model="estimate.clientMail.bcc[j]"
                @selected="mailSelected($event, estimate.clientMail.bcc, j)"
              ></WmsSuggestInput>
              <div class="m-auto ml-2">
                <TrashIcon class="text-gray-400 cursor-pointer hover:text-gray-500 active:text-gray-600 w-5 h-5" @click="bccDelete(j)"/>
              </div>
            </div>
          </div>
        </div>
        <!-- 参照画面 -->
        <div v-else-if="bcc.length" class="mb-3">
          <div class="flex justify-between">
            <div class="text-xs font-bold mt-auto text-gray-700">BCC</div>
          </div>
          <div v-for="(m, j) in bcc" :key="'cc'+j">
            <div class="border rounded border-gray-300 py-2 px-3 text-sm w-full">
              {{ bcc[j] }}
            </div>
          </div>
        </div>
        <!-- 件名 -->
        <div class="mb-3">
          <div class="text-xs font-bold mt-auto text-gray-700">件名
            <span v-if="edit" class="-top-0.5 ml-1 text-red-500"> * </span>
          </div>
          <input 
            type="text"
            class="cursor-text border-gray-300 rounded w-full focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            :class="!estimate.clientMail.subject?'bg-red-400':''"
            :disabled="!edit"
            v-model="estimate.clientMail.subject"
          />
        </div>
        <!-- 本文 -->
        <div class="mb-3">
          <div class="mb-1 flex items-end">
            <div class="text-xs font-bold text-gray-700 mb-1">本文<span v-if="edit" class="-top-0.5 ml-1 text-red-500"> * </span></div>
            <template v-if="edit">
              <!-- 本文テンプレート（選ぶと本文だけ作り直す） -->
              <div class="ml-5">
                <div class="text-xs font-bold text-gray-700">テンプレート</div>
                <select
                  class="text-xs border-gray-300 rounded py-1 focus:ring-indigo-500 focus:border-indigo-500"
                  :value="mailTemplateId"
                  @change="$emit('changeMailTemplate', Number($event.target.value))"
                >
                  <option v-for="t in templates" :key="t.id" :value="t.id">{{ t.name }}{{ t.isDefault ? '（デフォルト）' : '' }}</option>
                </select>
              </div>
              <!-- 追加文（本文のカーソル位置に差し込む） -->
              <div class="ml-3">
                <div class="text-xs font-bold text-gray-700">追加文</div>
                <select
                  class="text-xs border-gray-300 rounded py-1 focus:ring-indigo-500 focus:border-indigo-500"
                  :value="''"
                  v-tooltip="'本文の入れたい場所をクリックしてから選んでください'"
                  @change="selectSnippet($event)"
                >
                  <option value="">追加文選択</option>
                  <option v-for="s in snippets" :key="s.id" :value="s.id">{{ s.name }}</option>
                </select>
              </div>
              <PrimaryButton text="テンプレート・追加文の編集" size="xs" class="ml-auto" @click="$emit('openMailTemplate')" />
            </template>
          </div>
          <textarea
            v-if="edit"
            ref="bodyText"
            :rows="15"
            class="w-full rounded border border-gray-300"
            style="font-size: 0.8rem; field-sizing: content;"
            v-model="estimate.clientMail.text"
            @change="changeMailText"
            @click="saveCursor"
            @keyup="saveCursor"
            @select="saveCursor"
          />
          <div v-else class="bg-white rounded p-3 border border-gray-300 whitespace-pre-line" style="font-size: 0.8rem; w-full">
            {{ estimate.clientMail.text }}
          </div>
        </div>
      </div>

      <!-- 添付資料 -->
      <div class="ml-10">
        <label v-if="edit||attachments.length" class="block text-xs font-bold text-gray-700 bg-red-100 p-1">
          御見積書以外の添付ファイル<br>（上のお客様用添付ファイルと同じです）
        </label>
        <div class="bg-red-50">
          <!-- 上の添付と同じ順（メールに添付される順）で並べる -->
          <div v-if="edit" class="p-1 flex flex-col gap-2">
            <EstimateAttachment ref="mailAttachment1" name="mailAttachment1_1" :disabled="true" :value="estimate.mailAttachment1" :style="{ order: mailAttachmentPosition(1) }" @change="$emit('attachmentChange', 'mailAttachment1', $event)" @fileChange="fileChange('1', $event)" @emitClear="emitClear('1')" />
            <EstimateAttachment ref="mailAttachment2" name="mailAttachment2_1" :disabled="true" :value="estimate.mailAttachment2" :style="{ order: mailAttachmentPosition(2) }" @change="$emit('attachmentChange', 'mailAttachment2', $event)" @fileChange="fileChange('2', $event)" @emitClear="emitClear('2')" />
            <EstimateAttachment ref="mailAttachment3" name="mailAttachment3_1" :disabled="true" :value="estimate.mailAttachment3" :style="{ order: mailAttachmentPosition(3) }" @change="$emit('attachmentChange', 'mailAttachment3', $event)" @fileChange="fileChange('3', $event)" @emitClear="emitClear('3')" />
            <!-- 固定の添付（上の枠と一緒に並ぶ。外す・並べ替えは上の「お客様用添付ファイル」で） -->
            <div v-for="f in fixedAttachments" :key="f.key" class="flex flex-col items-center justify-center text-center text-sm px-2 py-8 border border-dashed border-gray-400 rounded bg-red-50" :style="{ order: mailAttachmentPosition(f.key) }">
              <div class="text-xs font-bold text-gray-600">固定の添付（{{ f.categoryName }}）</div>
              <a class="block text-indigo-700 underline cursor-pointer break-all mt-2" @click="openFixed(f)">{{ f.originalName }}</a>
            </div>
          </div>

          <div v-else class="p-1 text-sm text-gray-900">
            <div v-if="attachments.length" class="border border-gray-200 rounded">
              <template v-for="attachment in attachments">
                <!-- 固定の添付（枠の添付と同じ札の形。大きさの代わりに種別） -->
                <div v-if="attachment.fixed" :key="attachment.fileId" class="max-w-lg flex justify-center px-6 pt-5 pb-6 border border-gray-300 rounded-md bg-red-50">
                  <div class="space-y-1 text-center">
                    <Icon iconName="DocumentText" class="w-10 h-10 text-gray-400 mx-auto mb-2 cursor-pointer" @click.native="openFixed(attachment)" />
                    <div class="flex flex-col items-center text-xs text-gray-600">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 mb-2">固定（{{ attachment.categoryName }}）</span>
                      <a class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer break-words" @click="openFixed(attachment)">{{ attachment.originalName }}</a>
                    </div>
                  </div>
                </div>
                <EstimateAttachment v-else :key="attachment.fileId" :readonly="true" :value="attachment" class="bg-red-50" />
              </template>
            </div>
            <p v-else class="text-gray-800 font-bold" >
              ※御見積書以外に添付ファイルはありません。
            </p>
          </div>
        </div>

        <!-- 履歴 -->
        <div v-if="estimate.mailHistory && estimate.mailHistory.length" class="mt-10">
          <div class="text-xs font-bold text-gray-700">
            自動送信履歴
          </div>
          <div v-for="(row, i) in estimate.mailHistory" :key="'h'+i" class="text-sm">
            <div class="flex my-3">
              <div>・ {{ row.status }}</div>
              <div class="ml-5">{{ format(row.date) }}<div class="text-xs mt-1">送信先：{{ row.mail }}</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden">{{reload}}{{reload2}}</div>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import { TrashIcon } from '@vue-hero-icons/solid'
import EstimateAttachment from '../components/EstimateAttachment.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as logManager from '@managers/logManager'
import * as estimateManager from '@managers/estimateManager'
import * as estimateFixedAttachmentManager from '@managers/estimateFixedAttachmentManager'
import * as taskRequestManager from '@managers/taskRequestManager'
import * as mailTemplateManager from '@managers/mailTemplateManager'
import * as dialogs from '@libs/dialogs'
import moment from 'moment'

export default {
  components: {
    Icon,
    PrimaryButton,
    TrashIcon,
    EstimateAttachment,
    WmsSuggestInput
  },

  // mailTemplateList：本文テンプレートと追加文の一覧、mailTemplateId：選んでいるテンプレートの id（親が持つ）
  props: ['estimate', 'mainData', 'reload', 'edit', 'mailTemplateList', 'mailTemplateId'],

  data() {
    return {
      // ローディング
      waiting: '',
      // 本文のカーソル位置（追加文を入れる場所）。クリックするまで null
      bodyCursor: null,
      // 送信者リスト
      senderMailList: '',
      // メールマスタリスト
      mailList: [],
      // CCリスト
      ccList: [],
      // メールパス設定
      openMailPass: false,
      mailPass: '',
      reload2: 0
    }
  },

  computed: {
    /**
     * 本文テンプレートの一覧
     */
    templates() {
      return mailTemplateManager.templatesOf(this.mailTemplateList)
    },

    /**
     * 追加文の一覧
     */
    snippets() {
      return mailTemplateManager.snippetsOf(this.mailTemplateList)
    },

    editAttachments() {
      return estimateManager.getMailAttachmentsInOrder(this.estimate).filter((attachment) => {
        return (attachment && attachment.originalName)
      })
    },

    attachments() {
      return estimateManager.getMailAttachmentsInOrder(this.estimate).filter((attachment) => {
        return (attachment && attachment.fileId)
      })
    },

    /**
     * 固定の添付（見積の控え。編集のときの並び用）
     */
    fixedAttachments() {
      return estimateFixedAttachmentManager.activeOf(this.estimate).map((f) => estimateFixedAttachmentManager.toAttachment(f))
    },

    cc() {
      let res = []
      if (this.estimate.clientMail.cc && this.estimate.clientMail.cc.length) {
        res = this.estimate.clientMail.cc.filter((c) => {
          return c
        })
      }
      return res
    },

    bcc() {
      let res = []
      if (this.estimate.clientMail.bcc && this.estimate.clientMail.bcc.length) {
        res = this.estimate.clientMail.bcc.filter((c) => {
          return c
        })
      }
      return res
    },

    format() {
      return(val) => {
        return moment(val).format('YYYY/MM/DD HH:mm:ss')
      }
    }
  },

  watch: {
  },

  created() {
    this.getMailList()
    const list = this.$store.getters.userList
    let userName = this.$store.getters.user.user_name
    let userId = this.$store.getters.user.id

    if (this.edit) {
      this.senderMailList = list.filter((l) => {
        return userName == l.user_name || userId == l.id || this.estimate.taskStaff == l.user_name || this.estimate.taskStaffId == l.id || (this.estimate.clientMail.senderMail && this.estimate.clientMail.senderMail == l.e_mail_adress)
      })
    }
    this.ccList = list.filter((l) => {
      return l.user_name.indexOf('管理') == -1 && l.user_name.indexOf('未定') == -1
    })
  },

  methods: {
    /**
     * メアドリスト取得
     */
    async getMailList() {
      // お客様メアド取得
      if (this.edit) {
        const res = await backend.searchData('mail/getData', { type: 1 })
        if (res.data.data.length) {
          this.mailList = res.data.data
        }
        this.reload2++
      }
    },

    /**
     * 得意先メアド追加
     */
    mailAdd() {
      this.estimate.clientMail.mail.push('')
      this.reload2++
    },

    /**
     * CC追加
     */
    ccAdd() {
      this.estimate.clientMail.cc.push('')
      this.reload2++
    },

    /**
     * BCC追加
     */
    bccAdd() {
      this.estimate.clientMail.bcc.push('')
      this.reload2++
    },

    /**
     * メール削除
     */
    mailDelete(i) {
      this.estimate.clientMail.mail.splice(i, 1)
      if (!this.estimate.clientMail.mail || !this.estimate.clientMail.mail.length) {
        this.mailAdd()
      }
      this.reload2++
    },

    /**
     * CC削除
     */
    ccDelete(i) {
      this.estimate.clientMail.cc.splice(i, 1)
      if (!this.estimate.clientMail.cc || !this.estimate.clientMail.cc.length) {
        this.ccAdd()
      }
      this.reload2++
    },

    /**
     * BCC削除
     */
    bccDelete(i) {
      this.estimate.clientMail.bcc.splice(i, 1)
      if (!this.estimate.clientMail.bcc || !this.estimate.clientMail.bcc.length) {
        this.bccAdd()
      }
      this.reload2++
    },

    /**
     * 送信先メアドがマスタになければ保存
     */
    async saveMail(mail) {
      if (mail) {
        const res = this.mailList.find((m) => {
          return m.mail == mail
        })
        if (res && res.mail) {
          await dialogs.showErrorDialog('既に登録済み', '既に同じメールアドレスが登録済みです。')
          return
        }
        const param = {
          type: 1,
          mail,
          name: this.estimate.clientPersonName + '様',
          siteCode: this.mainData.siteCode,
          siteName: utils.zenkaku(this.estimate.buildingName),
          clientCode: this.estimate.clientCode,
          clientName: this.estimate.clientName,
          // siteAddress: this.estimate.buildingAddress2,
          usesrId: this.$store.getters.user.id,
          userName: utils.deleteKana(this.$store.getters.user.user_name)
        }
        await backend.postData('mail/save', param)
        this.getMailList()
        await dialogs.showSuccessDialog('保存完了', mail + ' を保存しました。')
      } else {
        alert('メールアドレスを入力してください。')
      }
    },

    /**
     * メール選択
     */
    mailSelected(e, target, i) {
      if (e.e_mail_adress) {
        target[i] = e.e_mail_adress
      } else if (e.mail) {
        target[i] = e.mail
      }
      this.reload2++
    },

    /**
     * メール本文変更
     */
    changeMailText() {
      this.estimate.sendMailChanged = true
    },

    /**
     * 本文のカーソル位置を覚える（追加文を入れる場所）
     */
    saveCursor(e) {
      const el = e && e.target ? e.target : this.$refs.bodyText
      if (el) {
        this.bodyCursor = { start: el.selectionStart, end: el.selectionEnd }
      }
    },

    /**
     * 追加文を選んだ：親に印の置き換えを頼む（置き換えた文は insertText で受け取る）
     */
    async selectSnippet(e) {
      const id = Number(e.target.value)
      // 選択欄は「追加文を入れる…」に戻す
      e.target.value = ''
      if (!id) {
        return
      }
      if (!this.bodyCursor) {
        await dialogs.showInfoDialog('入れる場所', '本文の入れたい場所をクリックしてから、追加文を選んでください。')
        return
      }
      const s = this.snippets.find((t) => t.id == id)
      if (s) {
        this.$emit('insertSnippet', s)
      }
    },

    /**
     * 本文のカーソル位置に文章を差し込む。前後が行の途中なら改行を補う
     * @param text 差し込む文章（印は置き換え済み）
     */
    insertText(text) {
      // カーソル位置は本文欄が持つ文字列（改行は \n）を基準に数えるので、同じ文字列を元にする
      // （データ側は \r\n のことがあり、そのまま使うと改行の数だけずれる）
      const el = this.$refs.bodyText
      const body = el ? el.value : (this.estimate.clientMail.text || '')
      const cur = this.bodyCursor || { start: body.length, end: body.length }
      const before = body.slice(0, cur.start)
      const after = body.slice(cur.end)
      let ins = text.replace(/\r\n/g, '\n')
      if (before && !before.endsWith('\n')) {
        ins = '\n' + ins
      }
      if (after && !after.startsWith('\n')) {
        ins = ins + '\n'
      }
      this.estimate.clientMail.text = before + ins + after
      this.estimate.sendMailChanged = true
      const pos = before.length + ins.length
      this.bodyCursor = { start: pos, end: pos }
      this.$nextTick(() => {
        const el = this.$refs.bodyText
        if (el) {
          el.focus()
          el.selectionStart = el.selectionEnd = pos
        }
      })
    },

    /**
     * お客様用添付ファイルの枠（または固定添付）が、メールに添付される順で何番目か
     * @param num 枠の番号（1〜3）か固定添付の印（'f' + id）
     */
    mailAttachmentPosition(num) {
      return estimateManager.getMailAttachmentOrder(this.estimate).indexOf(num) + 1
    },

    /**
     * 固定添付の PDF を別タブで開く（見積の控えのキーで）
     * @param f 固定添付
     */
    async openFixed(f) {
      try {
        await estimateFixedAttachmentManager.openFile({ fileKey: f.fileKey }, f.originalName)
      } catch (e) {
        console.log(e)
        await dialogs.showErrorDialog('固定の添付', 'PDF を開けませんでした。')
      }
    },

    /**
     * 添付ができているかの確認
     */
    async checkAttachment(es) {
      for (let i = 1; i < 4; i++) {
        let tar = 'mailAttachment' + i
        let tar2 = 'mailAttachment' + i
        let res2 = await this.$refs[tar].$refs.attachment.checkBytes(es[tar2])
        // 添付に失敗
        if (res2) {
          return true
        }
      }
      return false
    },

    /**
     * 見積画面の添付に変更あれば、こちらも更新
     */
    fileChange1(file) {
      this.$refs.mailAttachment1.setFile(file)
    },

    /**
     * 見積画面の添付に変更あれば、こちらも更新
     */
    fileChange2(file) {
      this.$refs.mailAttachment2.setFile(file)
    },

    /**
     * 見積画面の添付に変更あれば、こちらも更新
     */
    fileChange3(file) {
      this.$refs.mailAttachment3.setFile(file)
    },

    /**
     * 見積画面の添付も同期
     */
    fileChange(num, file) {
      if (num == 1) {
        this.$emit('fileChange1', file)
      } else if (num == 2) {
        this.$emit('fileChange2', file)
      } else if (num == 3) {
        this.$emit('fileChange3', file)
      }
    },

    /**
     * 添付削除で見積画面の添付も同期
     */
    emitClear(num) {
      this.$emit('emitClear', num)
    },

    /**
     * 添付削除同期
     */
    clear(num) {
      if (num == 1) {
        this.$refs.mailAttachment1.clear()
      } else if (num == 2) {
        this.$refs.mailAttachment2.clear()
      } else if (num == 3) {
        this.$refs.mailAttachment3.clear()
      }
    },

    /**
     * メールパス保存フォーム開閉
     */
    changeOpenMailPass(val) {
      this.openMailPass = val
    },

    /**
     * メールパス保存
     */
    async saveMailPass() {
      if (!this.mailPass) {
        alert('メールパスワードを入力してください。')
        return
      }
      await backend.postData('user/upDateMailPass', { mail: this.estimate.clientMail.senderMail, mailPass: this.mailPass })
      this.openMailPass = false
      logManager.recording(this, logManager.Loglevel.INFO, 'メールパスワード', this.estimate.clientMail.senderMail + ' のパスワードを変更しました。')
    },

    /**
     * 送信確認後、送信
     */
    async sendMail() {
      // メール自動送信ONの場合
      if (this.estimate.autoMail) {
        // 見積りの最新データを取得（複数タブ開いて何度も承認ボタンを押した可能性があるため）
        const es = await estimateManager.getEstimate(this, this.estimate.estimateNo)
        // 既にメール送信済みか否か
        let date = ''
        if (es.mailHistory) {
          if (es.mailHistory.length) {
            let dd = []
            for (let i = 0; i < es.mailHistory.length; i++) {
              const h = es.mailHistory[i]
              if (h.status == '成功') {
                dd.push(h.date)
              }
            }
            if (dd.length) {
              date = dd.join('、') + ' に'
            }
          }
        }

        await utils.estimateCalcYearly(this, this.estimate)

        // 送信済み
        if (date) {
          const dia = await dialogs.showWarningConfirmDialog('既にメール送信済みです', `${date}既にお客様へメール送信済みです。再度送信しますか？`, '送信する', '送信しない')
          if (dia == 'YES') {
            return await this.sending(es)
          } else {
            return '送信はしていません'
          }
        // 未送信
        } else {
          return await this.sending(es)
        }
      }
    },

    /**
     * メール送信
     * @param es 見積りデータ
     */
    async sending(es) {
      if (!es.mailHistory) {
        es.mailHistory = []
      }
      if (!this.estimate.mailHistory) {
        this.estimate.mailHistory = []
      }
      let sentMail = ''
      let history = {}
      try {
        // 見積書データ取得
        const pdf = estimateManager.buildPrintUrl(es, this.$store.getters.user.token, 'Estimate')
        // お客様用添付ファイル（画面で決めた順）
        const attachments = estimateManager.getMailAttachmentsInOrder(es).filter((attachment) => {
          return (attachment && attachment.fileId)
        })

        const param = {
          _id: es._id,
          estimateNo: es.estimateNo,
          clientMail: es.clientMail,
          attachments,
          printUrl: URL.parse(pdf.url),
          filename: pdf.filename
        }
        // メール送信
        const res = await backend.postData('estimateApproved/sendMail', param)

        if (res.data == 'complete') {
          // データ更新
          sentMail = '成功'
          history = { status: '成功', date: moment().format('YYYY-MM-DD HH:mm:ss'), mail: this.estimate.clientMail.mail.join('、') }
          // サブタスク更新
          await this.updateSubTask()
          // ログに保存
          logManager.recording(this, logManager.Loglevel.INFO, '見積書メール自動送信', '送信完了', '見積（見積番号：' + es.estimateNo + '）の見積書を' + es.clientMail.mail.join('、') + 'に送信しました。')

        // 失敗
        } else {
          alert('見積書メール自動送信失敗しました。\r\n' + res.data)
          history = { status: '失敗', date: moment().format('YYYY-MM-DD HH:mm:ss'), mail: this.estimate.clientMail.mail.join('、') }
          logManager.recording(this, logManager.Loglevel.ERROR, '見積書メール自動送信', '送信失敗', '見積（見積番号：' + es.estimateNo + '）の見積書を' + es.clientMail.mail.join('、') + 'に送信できませんでした。\r\n詳細：' + res.data)
        }
      } catch (error) {
        alert('見積書メール自動送信失敗しました。\r\n' + error)
        history = { status: '失敗', date: moment().format('YYYY-MM-DD HH:mm:ss'), mail: this.estimate.clientMail.mail.join('、') }
        // ログに保存
        logManager.recording(this, logManager.Loglevel.ERROR, '見積書メール自動送信', '送信失敗', '見積（見積番号：' + es.estimateNo + '）の見積書を' + es.clientMail.mail.join('、') + 'に送信できませんでした。\r\n' + error)
      }
      // データ更新
      es.mailHistory.push(history)
      await estimateManager.updateEstimate(this, es)
      // 画面に反映
      this.estimate.mailHistory.push(history)
      this.reload2++
      return sentMail
    },

    /**
     * 提出サブタスク完了
     */
    async updateSubTask() {
      // サブタスクを取得
      const sub = await taskRequestManager.getByRequestPostId(this, this.estimate.requestPostId, 'open')
      // 「提出」サブがあれば、完了にして更新
      let change = false
      for (let i = 0; i < sub.length; i++) {
        const s = sub[i]
        if (s.requestTask.indexOf('提出') > -1 && s.status == 'open') {
          sub[i] = taskRequestManager.changeStatusDone(s, '自動送信')
          change = await taskRequestManager.update(this, s)
          break
        }
      }

      // サブタスクのステータスを変更した場合
      if (change) {
        // 提出日を保存
        await taskRequestManager.saveEstimateSubmission(sub, this.$store.getters.user.id, null)
        // サブが全て完了したか確認し、完了していたらメインも完了にする
        await taskRequestManager.updateMainForAllSubDone(this, sub)
      }
    },
  }
}
</script>
<style scoped>
.mail-form {
  /* min-width: 500px; */
  width: 600px;
}
</style>